import React from 'react';

export default function ChildSwitcher({ children, selectedChild, onSelect }) {
  if (!children || children.length === 0) return null;
  if (children.length === 1) {
    // Single child — no switcher needed, show a compact info card
    const c = children[0];
    return (
      <div className="bg-white p-3 rounded shadow mb-4 flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold flex-shrink-0">
          {c.first_name[0]}
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 truncate">{c.name}</p>
          <p className="text-xs text-gray-500 truncate">
            {c.class_name} · {c.campus_name}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-3 rounded shadow mb-4">
      <p className="text-xs text-gray-500 mb-2 font-semibold uppercase tracking-wide">
        Select a child
      </p>
      <div className="flex flex-wrap gap-2">
        {children.map(c => {
          const isActive = selectedChild?.student_id === c.student_id;
          return (
            <button
              key={c.student_id}
              onClick={() => onSelect(c)}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold border transition ${
                isActive
                  ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
                  : 'bg-white text-gray-700 border-gray-300 hover:border-blue-400'
              }`}
            >
              <span className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0 ${
                isActive ? 'bg-white/25 text-white' : 'bg-blue-100 text-blue-700'
              }`}>
                {c.first_name[0]}
              </span>
              <span>{c.first_name}</span>
              <span className={isActive ? 'opacity-80' : 'text-gray-400'}>·</span>
              <span className={isActive ? 'opacity-80' : 'text-gray-500'}>{c.class_name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}